import api from './AxiosInstance';

export class CoordProfService{
  getAllCoordProf = async () => {
    try {
      const response = await api.get(`/CoordProf/List`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };

 
}